<template>
  <div class="create-author">
    <error :errors="authorError" />
    <author-form />
  </div>
</template>

<script>
  import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
  import authorForm from "../../../components/author/authorForm";
  import Error from "../../../partials/widgets/Error";
  import { mapGetters } from "vuex";
  export default {
    name: "index",
    components: { authorForm, Error },
    computed: {
      ...mapGetters(['authorError'])
    },
    mounted() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: " ئاپتور باشقۇرۇش", route: "list" },
        { title: "يېڭىدىن قوشۇش" }
      ]);
    }
  }
</script>
